import React from 'react';

import './style.scss';

const ButtonSpinner = props => (
    <div className={`button-spinner ${props.isLight ? 'button-spinner__light' : ''}`}>
        <span />
        <span />
        <span />
    </div>
)

export default ButtonSpinner;
